<template>
	<page-container :page="page">
		<heading-image
			v-if="page.headingImage"
			:heading-image="{
				image: page.headingImage,
				imageWebp: page.headingImageWebp,
				imagePortrait: page.headingImagePortrait,
				imagePortraitWebp: page.headingImagePortraitWebp,
			}"
		/>
		<main-content :title="page.title || page.header" :subtitle="page.subtitle" :content="page.content" />

		<section class="align-center availability">
			<div class="row">
				<div class="columns column12">
					<div class="huurkalender-embed huurkalender-embed-container_booking">
						<iframe
							id="iframe_huurkalender_booking3_19090"
							src="https://www.huurkalender.nl/vacancy/villa-schoolthoff-19090.html?type=iframe&lang=nl"
							frameborder="0"
							width="100%"
							allowfullscreen
						></iframe>
						<component
							:is="'script'"
							type="text/javascript"
							src="https://www.huurkalender.nl/online/embed/huurkalender.js"
						/>
					</div>
				</div>
			</div>
		</section>

		<contentblocks :items="page.contentblocks" />
		<frequently-asked-questions
			v-if="page.frequentlyAskedQuestion"
			:items="page.frequentlyAskedQuestion.faqitems"
			:header="page.frequentlyAskedQuestion.header"
		/>
	</page-container>
</template>

<script setup>
const { page, fetchPage } = usePage();

await fetchPage();
</script>

<style scoped lang="scss">
.availability {
	padding: 0 0 100px;
}

/* stylelint-disable selector-class-pattern */
.huurkalender-embed iframe {
	display: block !important;
}

.huurkalender-embed-container,
.huurkalender-embed-container_booking,
.huurkalender-embed-container_calendar {
	max-width: 100%;
}

.huurkalender-embed-container iframe,
.huurkalender-embed-container_booking iframe,
.huurkalender-embed-container_calendar iframe {
	width: 100%;
	min-height: 600px;
	background: 0 0;
}

.huurkalender-embed-container_overview {
	max-width: 100%;
	overflow: auto;
	-webkit-overflow-scrolling: touch;
}

.huurkalender-embed-container_overview iframe {
	width: 100%;
	min-height: 220px;
	background: 0 0;
}
/* stylelint-enable selector-class-pattern */
</style>
